"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelType = void 0;
var ChannelType;
(function (ChannelType) {
    ChannelType["UNDEFINED"] = "UNDEFINED";
    ChannelType["WHATSAPP"] = "WHATSAPP";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
//# sourceMappingURL=types.js.map